// libraries
import styled from 'styled-components';

export const StyledPushNoticeModalBody = styled.div`
  .modalBody {
    display: flex;

    > .modalImage {
    }

    > .modalInfo {
      display: inherit;
      width: 50%;
      flex-direction: column;
      justify-content: space-around;
    }

    > .modalInfoString {
      width: 100%;
    }
  }
`;
